import React from 'react';
import ModalActionButtons from '../../modal/ModalActionButtons';

export enum UploadStep {
  UPLOAD = 'UPLOAD',
  PREVIEW_MAPPING = 'PREVIEW_MAPPING'
}

interface ModalActionsProps {
  step: UploadStep;
  onCancel: () => void;
  onBack?: () => void;
  onConfirm?: () => void;
  /** When true, show "Importing data..." and disable actions during import */
  importing?: boolean;
}

const ModalActions: React.FC<ModalActionsProps> = ({
  step,
  onCancel,
  onBack,
  onConfirm,
  importing = false
}) => {
  return (
    <ModalActionButtons
      asDialogActions
      secondaryLabel={step === UploadStep.UPLOAD ? 'Cancel' : 'Back'}
      primaryLabel={
        step === UploadStep.PREVIEW_MAPPING
          ? importing
            ? 'Importing data...'
            : 'Confirm'
          : undefined
      }
      onSecondary={step === UploadStep.UPLOAD ? onCancel : (onBack ?? onCancel)}
      onPrimary={step === UploadStep.PREVIEW_MAPPING ? onConfirm : undefined}
      primaryDisabled={importing}
      secondaryDisabled={importing}
    />
  );
};

export default ModalActions;
